import React,{ Component } from 'react';
import {Row, Col, Button, Alert} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import { handleFieldChange } from "../../../../Utils";
import SelectWrap from "../../../../components/SelectWrap";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateFrom: '',
            dateTo: '',
            type: null,
            name: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit() {
        const isValid = this.validateForm();

        if(isValid) this.props.onSubmit({ ...this.state });
    }

    validateForm() {
        const { dateFrom, dateTo } = this.state;

        let alert = null;

        if(!dateFrom || !dateTo || dateFrom > dateTo) alert = 'Incorrect dates';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={['CREATE', 'UPDATE', 'DELETE', 'CLEAR', 'DEPLOY']}
                            label="Type:"
                            name="type"
                            onChange={this.handleFieldChange}
                            value={this.state.type}
                            multi
                        />
                    </Col>
                    <Col lg={2}>
                        <SelectWrap
                            values={this.props.names}
                            label="Name:"
                            name="name"
                            onChange={this.handleFieldChange}
                            value={this.state.name}
                            multi
                        />
                    </Col>
                </Row>

                <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={this.handleFormSubmit}>Load</Button>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/History/components/Form/index.js